import { mapEntityProperties } from '@/utils/mapEntityProperties'
import { ItemUnitMiniEntity } from '../../domain/entities/ItemUnitsMiniEntity'

export class ItemUnitMiniModel extends ItemUnitMiniEntity {
  constructor(dataDto: ItemUnitMiniEntity) {
    super()
    mapEntityProperties<ItemUnitMiniEntity>(this, dataDto)
  }
}
 